




















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Badge extends Vue {
    @Prop() private type!: string;
    @Prop() private value!: string;
    @Prop() private show!: boolean;

}
